import React from 'react';
import { Img } from '../../components';
import { Wrapper } from './Banner.styled';

function Shades({ shades }) {
	return (
		<div className="shades">
			{Array.from(Array(shades), (_, i) => {
				return <div key={i} />;
			})}
		</div>
	);
}

export default function Banner({ image, title, subtitle, shades = 2 }) {
	return (
		<Wrapper>
			<Img src={image.childImageSharp.gatsbyImageData} alt={title} />
			<Shades shades={shades} />
			<div className="banner_content">
				<div className="banner_text">
					<h1 className="title">{title}</h1>
					<h2 className="subtitle">{subtitle}</h2>
				</div>
			</div>
		</Wrapper>
	);
}
